import { render, staticRenderFns } from "./CodeExtract.vue?vue&type=template&id=b4ce3458&scoped=true&"
import script from "./CodeExtract.vue?vue&type=script&lang=js&"
export * from "./CodeExtract.vue?vue&type=script&lang=js&"
import style0 from "./CodeExtract.vue?vue&type=style&index=0&id=b4ce3458&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ce3458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4ce3458')) {
      api.createRecord('b4ce3458', component.options)
    } else {
      api.reload('b4ce3458', component.options)
    }
    module.hot.accept("./CodeExtract.vue?vue&type=template&id=b4ce3458&scoped=true&", function () {
      api.rerender('b4ce3458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CodeExtract.vue"
export default component.exports